
import { HiverAxios, showMessage } from 'h-commons';
import { GET_AUTORESP_DATA,GET_AUTORESP_DATA_FAILED} from './types';
const SM_ROOT = '/api/sm';


/**
 * Responsible for fetching auto responder data
 */
export function getAutoResp(smid) {
  return (dispatch) => {
   
    HiverAxios({
      url: `${SM_ROOT}/${smid}/autoresponders`,
      type: 'get',
     
      callback: (response) => {
        if (response.status !== 200) {
          showMessage({ message: 'failed to get data' })
          return;
        }
        response.data['smid']= smid;
        dispatch({
            type: GET_AUTORESP_DATA,
            payload:response.data
        });
      },
      onfail: () => {
        dispatch({
          type: GET_AUTORESP_DATA_FAILED,
          payload:[]
        });
        showMessage({ message: 'failed to get data', type: 'error' });
      }
    });
  };
}
